import loadable from '@loadable/component';

export type Coords = import('google-map-react').Coords;

export const LoadableGoogleMap = loadable(
  () => import(/* webpackChunkName: "GoogleMap" */ './HaGoogleMap'),
);
